/**
 * @generated SignedSource<<ce36881d1a72d3e5f571277511afa5ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_viewer">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_viewer";
};
export type PdpRespSidebarSellerInfoAndContactLazy_viewer$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSidebarSellerInfoAndContact_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "067b08fa463c2b9a8b14e1d256926fc3";

export default node;
